<template>
    <div>
        <div class="overlay" @click="closeModal"></div>
        <div class="modal modal--add-course-theme" @keyup.enter="uploadFile" @keyup.esc="closeModal">
            <h3 class="modal__text--content">{{ $t('upload_doc_pop') }}</h3>
            <button type="button" class="button button--icon button--modal-close" @click="closeModal">
                <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="7"
                        height="7"
                        viewBox="0 0 7 7"
                        fill="none"
                        class="icon icon--close"
                >
                    <path
                            d="M5.35363 0.252926L3.38886 2.21891L1.42288 0.252926C0.654 -0.515949 -0.523644 0.641014 0.25618 1.42084L2.22095 3.38561L0.25618 5.35159C-0.511478 6.11803 0.656433 7.28594 1.42288 6.51829L3.38886 4.55352L5.35363 6.51829C6.12129 7.28594 7.28798 6.11803 6.52154 5.35159L4.55556 3.38561L6.52154 1.42084C7.28798 0.653179 6.12129 -0.514732 5.35363 0.252926Z"
                            fill="#BDBDBD"
                    />
                </svg>
            </button>

            <div class="inner-block__field form-field" v-if="!get_doc_id_modal_upload_file">
                <label for="document_name" class="label">{{ $t('document_name') }}</label>
                <input
                        type="text"
                        v-validate="{required: true}"
                        name="document_name"
                        id="document_name"
                        v-model="document.name"
                        :class="{'validate-has-error' : errors.has('document_name')}"
                />
            </div>

<!--            <div class="form-field" v-if="!get_doc_id_modal_upload_file">-->
<!--                <label for="document_type" class="label">-->
<!--                    {{$t('document_type')}}-->
<!--                </label>-->
<!--                <multiselect-->
<!--                        ref="file"-->
<!--                        id="document_type"-->
<!--                        v-model="doc_type"-->
<!--                        :options="doc_type_list"-->
<!--                        track-by="name"-->
<!--                        label="name"-->
<!--                        :close-on-select="true"-->
<!--                        :placeholder="$t('choose_option')"-->
<!--                ></multiselect>-->
<!--            </div>-->

            <!-- <div class="inner-block__field form-field">
                <label for="document_upload" class="label">{{ $t('document_upload') }}</label>
                <input type="file" name="visibility" id="document_upload" @change="loadFile"/>
            </div> -->

            <FileUpload
                ref="upload"
                class="inner-block__field"
                :multiple="true"
                :accept="allowed_extensions"
                @updateFiles="updateFiles"
            />

            <p v-show="file_error" class="file-error">
                {{ $t('valid_file_types_2') }}
                {{ allowed_extensions.join(', ') }}
            </p>

            <div class="buttons-container">
                <button
                        class="button button--accent button--modal-action"
                        type="button"
                        @click="uploadFile"
                >
                    <span>{{ $t('document_upload_btn') }}</span>
                </button>
                <button class="button button--hollow button--modal-action" type="button" @click="closeModal">
                    {{ $t('cancel') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect'
    import helpers from "../../../helpers";
    import FileUpload from '../../../common_components/FileUpload';

    export default {
        inject: ['$validator'],
        props: [
            'studentId'
        ],
        components: {
            Multiselect,
            FileUpload,
        },
        data: () => ({
            doc_type: null,
            doc_type_list: [
                {
                    id: 1,
                    name: 'Нужно подписать'
                },
                {
                    id: 2,
                    name: 'Нужно ознакомиться'
                },
                {
                    id: 3,
                    name: 'Подписать'
                }
            ],
            document: {
                name: '',
                is_active: false
            },
            // file: null,
            files: [],
            allowed_extensions: [
                ".7z",
                ".rar",
                ".tar.gz",
                ".zip",
                ".jpeg",
                ".jpg",
                ".png",
                ".svg",
                ".xls",
                ".xlsx",
                ".doc",
                ".docx",
                ".odt",
                ".pdf",
                ".rtf",
                ".txt",
            ],
            file_error: false,
        }),
        computed: {
            ...mapGetters([
                'get_visibility_modal_upload_file',
                'get_type_modal_upload_file',
                'get_doc_id_modal_upload_file'
            ])
        },
        methods: {
            closeModal() {
                this.$validator.reset();
                this.$store.dispatch("setVisibilityModalUploadFile", {
                    show: false,
                    type: null,
                    doc_id: null
                });
            },
            // loadFile(event) {
            //     this.file = event.target.files[0];
            // },
            uploadFile(event) {
                this.$validator.validateAll().then(result => {

                    const isExtensionOk = this.files.every((file) => {
                        const fileExtension = "." + file.name.split(".").pop().toLowerCase();
                        return this.allowed_extensions.includes(fileExtension);
                    });

                    if (this.files.length === 0 || !isExtensionOk) {
                        this.file_error = true;
                        return;
                    }

                    this.file_error = false;

                    if (!result) return;

                    const docId = this.get_doc_id_modal_upload_file;

                    if (docId === undefined || docId === null) {
                        const query = {
                            name: this.document.name,
                            doc_file: this.files,
                            id: this.studentId,
                            // status: this.doc_type
                        };

                        this.$store.dispatch("SET_DOCUMENTS_PAYER", query)
                        .then(() => {
                            this.$store.commit('SET_REFRESH_PAGES', false);
                            this.$store.dispatch("setVisibilityModalUploadFile", {
                                show: false,
                                type: null,
                                doc_id: null
                            });
                        });
                    } else {
                        this.$store.dispatch("SET_DOCUMENT_SIGNATURE_PAYER", {
                            id: this.get_doc_id_modal_upload_file,
                            doc_file: this.files
                        })
                        .then(() => {
                            this.$store.dispatch("setVisibilityModalUploadFile", {
                                show: false,
                                type: null,
                                doc_id: null
                            });
                        });
                    }
                });
                // this.$validator.reset();
            },
            // uploadFile(event) {
            //     let $vm = this;
            //     this.$validator.validateAll().then(result => {
            //         if (result) {
            //             let file_extension = "." + this.file.name.split(".").pop();
            //             this.file_error = false;
            //             if (
            //                 this.allowed_extensions.find(
            //                     e => e === file_extension.toLowerCase()
            //                 ) === undefined
            //             ) {
            //                 this.file_error = true;
            //             } else {
            //                 this.file_loader = true;
            //                 if (this.get_doc_id_modal_upload_file === undefined || this.get_doc_id_modal_upload_file === null) {
            //                     this.$store.dispatch("SET_DOCUMENTS_PAYER", {
            //                         name: this.document.name,
            //                         doc_file: this.file,
            //                         id: this.studentId,
            //                         // status: this.doc_type
            //                     });
            //                     this.$store.commit('SET_REFRESH_PAGES', false)
            //                 } else {
            //                     this.$store.dispatch("SET_DOCUMENT_SIGNATURE_PAYER", {
            //                         id: this.get_doc_id_modal_upload_file,
            //                         doc_file: this.file
            //                     });
            //                 }

            //                 this.$store.dispatch("setVisibilityModalUploadFile", {
            //                     show: false,
            //                     type: null,
            //                     doc_id: null
            //                 });

            //                 // const input = this.$refs.file;
            //                 // input.forEach(e => {
            //                 //     e.type = "text";
            //                 //     e.type = "file";
            //                 // });
            //             }
            //         }
            //     });
            //     this.$validator.reset();
            // },
            updateFiles(filesArr) {
            this.files = filesArr;
            this.file_error = false;
            },
        },
    };
</script>

<style scoped lang="sass">
    @import "../../../../sass/modals"
    .validate-has-error
        border: solid 1px red !important

    .file-error
        color: red
        margin-top: 15px
        font-size: 12px
        text-align: left
</style>
